export default __webpack_public_path__ + "static/media/Logo_AcquaMonitoring.a308c854.svg";